import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyPaymentRequestOverview = lazyWithRetry(
  () => import("./PaymentRequestOverview"),
);

const PaymentRequestOverview = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyPaymentRequestOverview {...props} />;

export default PaymentRequestOverview;
